import type React from 'react';

import * as st from './styles.module.scss';

interface Props {
	children: React.ReactNode;
}

export const Month: React.FC<Props> = ({ children }) => {
	const weekdays = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'];

	return (
		<div className={st.month}>
			<section className={st.weekdays}>
				{weekdays.map((day) => (
					<div className={st.weekdays__day} key={day}>
						{day}
					</div>
				))}
			</section>
			<section className={st.weeks}>{children}</section>
		</div>
	);
};
